<template>
  <div class="v2-ship-step">
    <h3 class="v2-ship-step__title">
      {{ title }}
    </h3>
    <p class="v2-ship-step__subtitle">
      {{ subtitle }}
    </p>

    <v2-dropdown
      :options="collectionOptions"
      :value="selectedCollectionId"
      placeholder="Select collection..."
      :searchable="true"
      label-key="label"
      value-key="value"
      :empty-text="isLoading ? 'Loading collections…' : 'No collections found.'"
      @select="onSelect"
    />
  </div>
</template>

<script>
import store from '@/store'
import { GET_COLLECTION_LIST } from '@/store/modules/collection.module'
import V2Dropdown from '@/components/v2/V2Dropdown.vue'

export default {
  name: 'V2ShipAllCollectionStep',
  components: { V2Dropdown },
  props: {
    selectedCollectionId: { type: String, default: '' },
    // Copy is overridable so the step can be reused by flows that are not
    // creating shipments. Defaults keep the Ship All wording unchanged.
    title: { type: String, default: 'Select a Collection' },
    subtitle: {
      type: String,
      default: 'Choose the collection you want to create shipments for.',
    },
  },
  data() {
    return {
      collections: [],
      isLoading: false,
    }
  },
  computed: {
    collectionOptions() {
      return this.collections.map(c => ({
        label: c.name,
        value: c._id,
        status: c.status,
      }))
    },
  },
  created() {
    this.loadCollections()
  },
  methods: {
    async loadCollections() {
      this.isLoading = true
      try {
        const res = await store.dispatch(GET_COLLECTION_LIST)
        this.collections = res?.data?.data?.collections || []
      } catch {
        this.collections = []
      } finally {
        this.isLoading = false
      }
    },
    onSelect(value) {
      const id = typeof value === 'object' ? value.value : value
      const match = this.collections.find(c => c._id === id)
      if (match) this.$emit('select', { id: match._id, name: match.name })
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-ship-step {
  padding: var(--v2-space-2) var(--v2-space-1);

  &__title {
    font-family: var(--v2-font-display);
    font-size: 1rem;
    font-weight: 600;
    color: var(--v2-foreground);
    margin: 0 0 var(--v2-space-2) 0;
  }

  &__subtitle {
    font-size: 0.875rem;
    color: var(--v2-muted-foreground);
    margin: 0 0 var(--v2-space-4) 0;
  }
}
</style>
